import { Store } from '@ngxs/store';
import { Member } from 'src/app/models/member';
import { ProductOrchestratorService } from 'src/app/services/+products/product-orchestrator.service';
import { MemberService } from 'src/app/services/member/member.service';
import { IInterviewHandler } from 'src/app/shared/interview-new/models/interview-handler.models';

import { BaseProductService } from '../+products/-base-product.service';
import { BaseProductStateModel } from '../+products/base-product-state.models';
import {
    InterviewDefaultDataProviderService,
} from '../../shared/interview-new/instances/data-providers/interview-default-data-provider.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { AssessmentType, IEvaluationResult } from '../interview/interview.model';



export abstract class InterviewProductDataProviderService extends InterviewDefaultDataProviderService {

    readonly defaultInterviewType = 'Eligibility';

    get interviewFinalizer() {
        return this.productService;
    }

    constructor(protected store: Store,
        public productService: BaseProductService<BaseProductStateModel>,
        public productOrchestratorService: ProductOrchestratorService,
        private readonly appInsightsService: AppInsightsService
    ) {
        super();
    }

    async configure(context: any) {
        return { ...(await super.configure(context)), type: this.defaultInterviewType };
    }

    async canInitializeInterview(handler?: IInterviewHandler) {
        let $case = await this.productService.getOrAddCase(AssessmentType.Eligibility);
        if ($case == null) {
            try {
                this.appInsightsService.logException(new Error(`CANNOT INITIALIZING INTERVIEW Case not retrieved by getOrAddCase inside interview data provider(fn: initialize) for ${this.productService.productCategory || 'N/A'} primary: ${handler?.isPrimary}, member: ${this.store.selectSnapshot<Member>(MemberService.member)?.base64 || 'N/A'}, User: ${this.productService.userService.userSync?.email || 'N/A'}`), 'abstract-interview-product-data-provider.service.ts', { currentCase: { ...this.productService.currentCaseSync }, context: { ...this.productService.publicProductCategoryContext } });
            } catch (error) {
                this.appInsightsService.logException(new Error(`INITIALIZING INTERVIEW ERROR LOGGING: Second Try: Case not retrieved by getOrAddCase inside interview data provider(fn: initialize) for ${this.productService.productCategory || 'N/A'}, member: ${this.store.selectSnapshot<Member>(MemberService.member)?.base64 || 'N/A'}, User: ${this.productService.userService.userSync?.email || 'N/A'}`), 'abstract-interview-product-data-provider.service.ts', { originalError: error });
            }
        }

        if (handler?.isPrimary) {
            this.productOrchestratorService.setPrimaryInterview(handler);
        }

        return !!$case;
    }

    async generateContextData(contextData: any, input?: any) {
        if (this.productService.currentCaseSync == null) {
            this.appInsightsService.logException(new Error(`INTERVIEW CONTEXT DATA GENERATION: Case not retrieved by getOrAddCase inside interview data provider(fn: generateContextData) for ${this.productService.productCategory || 'N/A'} primary: ${this.productService.interviewHandler?.isPrimary}, member: ${this.store.selectSnapshot<Member>(MemberService.member)?.base64 || 'N/A'}, User: ${this.productService.userService.userSync?.email || 'N/A'}`));
        }

        return {
            ...(await super.generateContextData(contextData)),
            Member: this.store.selectSnapshot<Member>(MemberService.member),
            Case: this.productService.currentCaseSync,
            entityId: contextData?.entityId || this.productService.currentCaseSync?.id, // HACK to add/overwrite generateContextData's "entityId"
            entityType: contextData?.entityType || 'Case',
            tenantId: contextData?.tenantId || this.store.selectSnapshot<string>(MemberService.tenantId)
        };
    }

    processEvaluation(evaluationResult: IEvaluationResult) {
        if (evaluationResult?.interviews[0]?.completion) {
            this.productService.setCaseCurrentStateCompletion(evaluationResult.interviews[0].completion);
        }
    }

}
